import { useMemo } from 'react';
import {
  useCreateAssemblyFolderMutation,
  useCreateItemFolderMutation,
  useCreateProjectFolderMutation,
  useDeleteAssemblyFolderMutation,
  useDeleteItemFolderMutation,
  useDeleteProjectFolderMutation,
  useUpdateAssemblyFolder,
  useUpdateItemFolder,
  useUpdateProjectFolder,
} from '../../../hooks/useFetchFolders';

export const useFolderMutation = (folderType: string) => {
  const projectMutation = useCreateProjectFolderMutation();
  const assemblyMutation = useCreateAssemblyFolderMutation();
  const itemMutation = useCreateItemFolderMutation();

  const updateProjectFolder = useUpdateProjectFolder();
  const updateAssemblyFolder = useUpdateAssemblyFolder();
  const updateItemFolder = useUpdateItemFolder();

  const deleteProjectFolder = useDeleteProjectFolderMutation();
  const deleteAssemblyFolder = useDeleteAssemblyFolderMutation();
  const deleteItemFolder = useDeleteItemFolderMutation();

  const createMutation = useMemo(() => {
    switch (folderType) {
      case 'project':
        return (data: any, options?: any) => projectMutation.mutate(data, options);
      case 'assembly':
        return (data: any, options?: any) => assemblyMutation.mutate(data, options);
      case 'item':
        return (data: any, options?: any) => itemMutation.mutate(data, options);
      default:
        return () => {};
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folderType, projectMutation.mutate, assemblyMutation.mutate, itemMutation.mutate]);

  const updateMutation = useMemo(() => {
    switch (folderType) {
      case 'project':
        return (data: any, options?: any) => updateProjectFolder.mutate(data, options);
      case 'assembly':
        return (data: any, options?: any) => updateAssemblyFolder.mutate(data, options);
      case 'item':
        return (data: any, options?: any) => updateItemFolder.mutate(data, options);
      default:
        return () => {};
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    folderType,
    updateProjectFolder.mutate,
    updateAssemblyFolder.mutate,
    updateItemFolder.mutate,
  ]);

  const deleteMutation = useMemo(() => {
    switch (folderType) {
      case 'project':
        return (data: any, options?: any) => deleteProjectFolder.mutate(data, options);
      case 'assembly':
        return (data: any, options?: any) => deleteAssemblyFolder.mutate(data, options);
      case 'item':
        return (data: any, options?: any) => deleteItemFolder.mutate(data, options);
      default:
        return () => {};
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    folderType,
    deleteProjectFolder.mutate,
    deleteAssemblyFolder.mutate,
    deleteItemFolder.mutate,
  ]);

  return { createMutation, updateMutation, deleteMutation };
};
